// extracted by mini-css-extract-plugin
export default {"btop":"d8e47eed02 _98fd3de923 a87e5b87b4","icon":"_3e6c39a18c d2ec2016e2","btoppink":"fe5ee444da _76be3caeeb"};